import Splide from "../splide.min.js";

"use strict";
var jschecker;

function init() {
      if (jschecker = checkLoaded()) {
            var e = function (e, t) {
                  document.querySelector(t) && document.querySelector(e).addEventListener("click", function () {
                        window.scrollTo({
                              top: document.querySelector(t).offsetTop - 110,
                              behavior: "smooth"
                        })
                  })
            },
                  s = function (t) {
                        return new Promise(function (e) {
                              return setTimeout(e, t)
                        })
                  },
                  t = function () {
                        for (var i = new Splide("#splideQuestionImage", {
                              type: "fade",
                              perPage: 1,
                              rewind: !1,
                              autoPlay: !1,
                              arrows: !1,
                              pagination: !1,
                              drag: !1,
                              keyboard: !1,
                              wheel: !1
                        }), o = new Splide("#splideQuestion", {
                              type: "slide",
                              perPage: 1,
                              rewind: !1,
                              autoPlay: !1,
                              arrows: !1,
                              pagination: !1,
                              drag: !1,
                              keyboard: !1,
                              wheel: !1
                        }), n = o.root.querySelector(".my-carousel-progress-bar"), e = 0; e < u.length; e++) u[e].addEventListener("click", function () {
                              t(this)
                        });

                        function t(e) {
                              document.querySelectorAll(".splide__slide.is-active.is-visible .nb_btn_response").forEach(function (e) {
                                    e.classList.remove("rsp_selected")
                              }), e.classList.add("rsp_selected"), v && (S.push(e.dataset.id), console.log("Resultat : " + S), v = !1);
                              var t = l(S, r);
                              if (t) console.log("selec find : " + t.selec),
                                    function (e) {
                                          console.log("getResult launch"), console.log(e), 1023 < window.innerWidth ? (a.style.transition = "width 0.5s", a.style.width = "100%", g.style.transition = "right 0.5s", g.style.right = "-50%", h.style.transition = "left 0.5s", h.style.left = "-50%") : (a.style.transition = "width 0.5s", a.style.width = "100%", g.style.transition = "right 0.5s", g.style.right = "-100%"), s(100).then(function () {
                                                a.style.display = "flex"
                                          }), s(500).then(function () {
                                                a.style.display = "flex", _.style.transition = "left 0.5s", _.style.left = "0%", y.style.transition = "right 0.5s", y.style.right = "0"
                                          });
                                          var t = e.split(",");
                                          1 == t.length ? document.querySelector("#" + t[0]) && (document.querySelector("#" + t[0]).style.display = "flex", document.querySelector("#" + t[0]).classList.add("only")) : t.forEach(function (e) {
                                                document.querySelector("#" + e) && (document.querySelector("#" + e).style.display = "flex")
                                          })
                                    }(t.selec);
                              else {
                                    (function (e, t, n, s) {
                                          console.log(" ----------- Exception --------- ");
                                          var l = document.querySelector(n);
                                          return JSON.stringify(e) == JSON.stringify(t) ? (l.classList.contains("x-display-none") || l.classList.add("x-display-none"), o.go(">"), i.go(">"), !0) : (l.classList.contains("x-display-none") && l.classList.remove("x-display-none"), !1)
                                    })(S, ["1", "5"], "#splideQuestion-slide03"), 0 == function (e, t, n) {
                                          console.log(" ----------- Exception --------- ");
                                          var s = document.querySelector('[data-id="' + n + '"]');
                                          return e[0] == t[0] ? (s.classList.contains("x-display-none") || s.classList.add("x-display-none"), o.go(">"), i.go(">"), !0) : (s.classList.contains("x-display-none") && s.classList.remove("x-display-none"), !1)
                                    }(S, ["3"], 4) && (o.go(">"), i.go(">"))
                              }
                        }
                        c.addEventListener("click", function () {
                              v && (S.pop(), v = !1), o.go("<"), i.go("<")
                        }), o.on("moved", function () {
                              m[0].classList.contains("is-active") && !c.classList.contains("x-display-none") ? c.classList.add("x-display-none") : c.classList.remove("x-display-none"), v = !0
                        }), o.on("mounted", function () {
                              p.addEventListener("click", function () {
                                    ! function () {
                                          console.log("backToZero launch"), S.length = 0, a.style.width = "100%", 1023 < window.innerWidth ? (_.style.left = "-50%", y.style.right = "-50%") : (_.style.left = "-100%", y.style.right = "-100%"), o.go(0), i.go(0);
                                          for (var e = 0; e < f.length; e++) f[e].style.display = "none", f[e].classList.contains("only") && f[e].classList.remove("only");
                                          s(500).then(function () {
                                                g.style.right = "0%", h.style.left = "0%"
                                          }), s(1500).then(function () {
                                                a.style.display = "none"
                                          });
                                          for (var t = 0; t < u.length; t++) u[t].checked = !1, u[t].classList.contains("rsp_selected") && u[t].classList.remove("rsp_selected")
                                    }()
                              })
                        }), o.on("mounted move", function () {
                              var e = o.Components.Controller.getEnd() + 1,
                                    t = Math.min((o.index + 1) / e, 1);
                              n.style.width = String(100 * t) + "%"
                        }), o.mount(), i.mount()
                  },
                  l = function (e, t) {
                        var n = e.join();
                        return t.find(function (e) {
                              return e.result == n
                        })
                  };
            console.log("Script started"), e("#guide", "#guide-destination"), e("#jeu", "#luckyCycle_id"), e("#quizz", "#numero_Quizz_2023");
            var n = document.querySelectorAll(".flip-card"),
                  i = !1;
            n.forEach(function (e) {
                  e.addEventListener("click", function () {
                        e.classList.contains("hover") ? e.classList.remove("hover") : e.classList.add("hover")
                  }), 1023 < window.innerWidth && (e.addEventListener("mouseenter", function () {
                        i = (e.classList.contains("hover") || i ? e.classList.remove("hover") : e.classList.add("hover"), !0)
                  }), e.addEventListener("mouseleave", function () {
                        i = !1
                  }))
            });
            document.getElementById("background_video"), document.getElementById("myVideo");
            var r = [{
                  result: "1,4,9",
                  selec: "cosy_wireless_n2_SA_classique"
            }, {
                  result: "1,4,8",
                  selec: "n2,n3"
            }, {
                  result: "1,7",
                  selec: "n9"
            }, {
                  result: "1,5,10",
                  selec: "CF_SA_triangle"
            }, {
                  result: "1,5,11",
                  selec: "SC_SA_classique"
            }, {
                  result: "1,6",
                  selec: "n8,SC_SA_brassiere,SC_SA_triangle"
            }, {
                  result: "2,4,9",
                  selec: "cosy_wireless_n2_SA_classique"
            }, {
                  result: "2,4,8",
                  selec: "n2,n3"
            }, {
                  result: "2,7",
                  selec: "n9"
            }, {
                  result: "2,5,8,10",
                  selec: "n4,n5,CF_arm_classique"
            }, {
                  result: "2,5,9,10",
                  selec: "CF_SA_triangle,cosy_wireless_n5"
            }, {
                  result: "2,5,8,11",
                  selec: "SC_arm_classique"
            }, {
                  result: "2,5,9,11",
                  selec: "SC_SA_classique"
            }, {
                  result: "2,6,8",
                  selec: "n7"
            }, {
                  result: "2,6,9",
                  selec: "n8"
            }, {
                  result: "3,7",
                  selec: "n9"
            }, {
                  result: "3,5,8,10",
                  selec: "n4,n5,n6,CF_arm_classique"
            }, {
                  result: "3,5,9,10",
                  selec: "CF_SA_triangle,cosy_wireless_n5"
            }, {
                  result: "3,5,8,11",
                  selec: "SC_arm_classique"
            }, {
                  result: "3,5,9,11",
                  selec: "SC_SA_classique"
            }, {
                  result: "3,6,8",
                  selec: "n7,minimizer"
            }, {
                  result: "3,6,9",
                  selec: "n8"
            }],
                  o = document.querySelector("#beginBtn"),
                  c = (document.querySelector(".nb_next"), document.querySelector(".nb_prev")),
                  u = document.querySelectorAll(".nb_btn_response"),
                  a = document.querySelector(".nb_result"),
                  d = document.querySelector(".nb_result_description"),
                  y = document.querySelector("._nb_result_item"),
                  _ = document.querySelector("._nb_result_item_text"),
                  f = (document.querySelector("._nb_result_item_display"), document.querySelectorAll("._nb_result_item_display_bloc")),
                  m = document.querySelectorAll(".splide__slide"),
                  g = document.querySelector(".nb_body"),
                  h = document.querySelector(".nb_bodyImage"),
                  p = document.querySelector(".nb_retry"),
                  S = [],
                  v = !0,
                  q = function () {
                        var e = .01 * window.innerHeight;
                        document.documentElement.style.setProperty("--vh", "".concat(e, "px"))
                  };
            window.addEventListener("resize", q), q(), o.addEventListener("click", function () {
                  1023 < window.innerWidth ? (d.style.transition = "left 0.5s", d.style.left = "-100%", s(500).then(function () {
                        d.style.display = "none"
                  }), s(1e3).then(function () {
                        g.style.transition = "right 0.5s", g.style.right = "0%", h.style.transition = "left 0.5s", h.style.left = "0%", a.style.display = "none", a.style.backgroundImage = "none"
                  })) : (d.style.transition = "left 0.5s", d.style.left = "-100%", s(500).then(function () {
                        d.style.display = "none", a.style.backgroundImage = "none", a.style.transition = "width 0.5s", a.style.width = "0%", g.style.transition = "right 0.5s", g.style.right = "0%"
                  }))
            }),
                  function e() {
                        "undefined" != typeof Splide ? s(1e3).then(function () {
                              return t()
                        }) : setTimeout(e, 500)
                  }()
      } else setTimeout(init)
}

function checkLoaded() {
      return console.log("page is fully loaded"), !0
}
init();